<template>
  <div
    class="d-reviewer-directory-entry"
    :class="{
      'background-grey-base': isExpanded,
    }"
    @click="toggleExpanded"
  >
    <div
      class="header grid grid-no-response"
      :class="{ 'border-top': isFirstEntry }"
    >
      <div class="avatar">
        <img
          :src="entry.avatar_url"
          :alt="entry.name"
        >
      </div>

      <div class="user-info grid grid-no-response">
        <p class="username large font-alt">
          <a
            class="no-decoration"
            :href="userProfileUrl"
            @click.stop
          >
            {{ entry.name }}
          </a>
        </p>

        <p class="ellipsis space-bottom-none">
          <span
            v-if="entry.followers > 0"
            class="followers space-right-2em"
          >
            {{ entry.followers | duiThousands }} {{ entry.followers | duiPluralize('follower', 'followers') }}
          </span>
          <span class="genres">{{ entry.genres }}</span>
        </p>
      </div>
    </div>

    <div class="content border-bottom">
      <p
        v-if="!!entry.about"
        class="about font-alt"
      >
        <span v-if="!isExpanded">
          {{ entry.about | duiTruncate(300) }}
        </span>

        <span v-else>
          {{ entry.about }}
        </span>

        <a
          v-if="!isExpanded"
          class="read-more bold"
          title="Read more"
        >
          read more...
        </a>
      </p>

      <div v-if="isExpanded">
        <div class="book-previews">
          <a
            v-for="(book, index) in entry.books"
            :key="index"
            :href="getBookUrl(book.id)"
            :title="book.title"
            class="book-preview"
            @click.stop
          >
            <img
              :src="book.covers.medium.url"
              :alt="book.title"
            >
          </a>
        </div>

        <div class="grid-flex grid-no-response space-bottom-2em">
          <a
            class="button button-white-bordered"
            :href="userProfileUrl"
            @click.stop
          >
            View profile
          </a>

          <a
            v-if="!entry.is_current_user"
            class="button button-yellow"
            :href="entry.request_review_url"
            @click.stop="requestReview"
          >
            Request a review
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URLS from '@d-shared/urls/urls';
import Vue from 'vue';

export default {
  props: {
    entry: {
      type: Object,
      required: true,
    },
    isFirstEntry: {
      type: Boolean,
      default: false,
    },
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isExpanded: false,
  }),
  computed: {
    userProfileUrl() {
      return URLS.app.userProfile.entry.replace('<username>', this.entry.username);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    toggleExpanded() {
      this.$set(this, 'isExpanded', !this.isExpanded);
    },

    init() {
      this.$set(this, 'isExpanded', this.isFirstEntry);
    },

    requestReview(e) {
      if (this.isUserSignedIn) return;

      e.preventDefault();
      Vue.prototype.signupModal.show();
    },
    getBookUrl(slug) {
      return URLS.app.book.replace('<book-slug>', slug);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-reviewer-directory-entry {
  cursor: pointer;
  margin: 0 (-$_2em);
  padding: 0 $_2em;

  @include transition((
    background-color
  ));

  &:hover {
    background-color: getColor($grey, base);
    cursor: pointer;
  }

  .header {
    align-items: start;
    grid-template-columns: $_8em 1fr;
    grid-gap: $_2em;
    padding: $_2em 0 $_1em;

    :last-child {
      border-bottom: none;
    }

    .avatar {
      position: relative;

      img {
        border-radius: 50%;
        display: block;
        height: $_8em;
        width: $_8em;
      }
    }

    .user-info {
      .username {
        margin: 0;
      }


    }
  }

  .content {
    .about {
      margin: 0 0 $_2em;
    }

    .book-previews {
      display: flex;
      margin-bottom: $_2em;
      overflow-x: auto;

      @include screenLessThan(md) {
        .book-preview {
          flex-shrink: 0;
          margin-right: $_2-5em;
          width: $book-cover-width-xs;
          height: $book-cover-height-xs;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      @include screenMoreThan(sm) {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        grid-gap: $_2em;
      }

      & img {
        box-shadow: $box-shadow-sm;
        border-radius: $_1em;
        display: block;
        height: 100%;
        object-fit: cover;
        width: 100%;
      }
    }
  }
}
</style>
